import * as React from 'react'

import Stack from '@mui/material/Stack'

import { RequiredTextField } from './RequiredTextField'

/**
 * Street, city, state and postal code inputs for the Address additional field. Street 2 is
 * optional and never blocks submit. State is a two-letter abbreviation.
 */
export function AddressFields() {
  return (
    <Stack spacing={2}>
      <RequiredTextField
        name="street1"
        label="Street 1"
        testId="auto-review-street1"
      />
      <RequiredTextField
        name="street2"
        label="Street 2"
        testId="auto-review-street2"
        required={false}
      />
      <RequiredTextField name="city" label="City" testId="auto-review-city" />
      <RequiredTextField
        name="stateAbbreviation"
        label="State"
        testId="auto-review-state"
        maxLength={2}
      />
      <RequiredTextField
        name="postalCode"
        label="Postal Code"
        testId="auto-review-postal-code"
      />
    </Stack>
  )
}
AddressFields.displayName = 'AddressFields'
